import * as angular from 'angular';

import { ComponentDefinition, DateRange, RefreshClickData } from '../../models';
import { IAuthenticationService, IUserService, IDateRangeService } from '../../services';
import { refreshClick, compare } from '../../common';

class CompareMenuController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    selectedPeriod: string;
    compareType: string;
    savedDates;
    selectedDates;
    isSavedDatesLoading: boolean;
    isSelectedDatesLoading: boolean;
    selectedRange: DateRange;

    static $inject = [
        '$scope',
        '$rootScope',
        'authenticationService',
        'userService',
        'dateRangeService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _authenticationService: IAuthenticationService,
        private _userService: IUserService,
        private _dateRangeService: IDateRangeService
    ) {
    }

    $onInit() {
        this.compareType = 'Default';
        this.selectedPeriod = 'None';
        const userName = this._authenticationService.authentication.userName;
        if (userName) {
            this.isSavedDatesLoading = true;
            this._userService
                .getSavedDatesForUser(userName)
                .then((data) => {
                    this.savedDates = data.savedDates;
                    this.isSavedDatesLoading = false;
                },
                    (_reason) => this.isSavedDatesLoading = false);

            this.isSelectedDatesLoading = true;
            this._userService
                .getSelectedDatesForUser(userName)
                .then((data) => {
                    this.selectedDates = data.selectedDates;
                    this.isSelectedDatesLoading = false;
                },
                    (_reason) => this.isSelectedDatesLoading = false);

            this._$scope.$on(refreshClick, (_event, _data: RefreshClickData) => this.compare());
        }
    }

    compare() {
        const compareResult = !!this.selectedPeriod && this.selectedPeriod !== 'None';
        this._dateRangeService.compare(compareResult);
        this._dateRangeService.comparePeriod(this.selectedPeriod);
        if (this.selectedPeriod === 'custom') {
            this._dateRangeService.compareRange(this.selectedRange);
        }
        this._$rootScope.$broadcast(compare);
    }

    selectDate(dateRange: DateRange) {
        this.selectedPeriod = 'custom';
        this.selectedRange = dateRange;
    }

    stopPropagation($event: angular.IAngularEvent) {
        $event.stopPropagation();
    }
}

export const wtCompareMenu: ComponentDefinition = {
    componentId: 'wtCompareMenu',
    controller: CompareMenuController,
    template: require('./compareMenu.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
